import React, { useCallback, useEffect, useMemo } from 'react';
import { environment } from 'api';
import { useMount } from 'ahooks';
import cls from 'classnames';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import GuideCarousel from '@web-common/components/NotificationPopup/GuideCarousel';
import { Modal } from '@web-common/components/UI';
import { PopupActions } from '@web-common/state/reducer';
import { popupIdSelector } from '@web-common/popup_state/selector';
import styles from './index.module.scss';
export const env = typeof environment === 'string' ? environment : 'local';
export const isDev = !['prod', 'prev'].includes(env);
const PopupNotification = ({ status, children, winConfig, carouselConfig, renderConfig = {}, manualVisible, onShow, onClose, className, }) => {
    const { winType, id, showOnceMoreEachDay, forModuleId, renderType, title, notShowPeriod = 0, priority = 1, forNew, closeConfirm } = winConfig;
    const dispatch = useAppDispatch();
    const winId = useMemo(() => `${winType}/${id}`, [winType, id]);
    const winItem = useAppSelector(state => popupIdSelector(state.popupReducer, winId));
    const winVisible = useMemo(() => (winItem === null || winItem === void 0 ? void 0 : winItem.status) === 'OPEN', [winItem === null || winItem === void 0 ? void 0 : winItem.status]);
    const realVisible = useMemo(() => (winVisible && status === 'show') || manualVisible, [winVisible, manualVisible, status]);
    const closeWin = useCallback((type, force = false) => {
        if (force || (!closeConfirm && !manualVisible)) {
            dispatch(PopupActions.openOrCloseWin({ winId, status: 'CLOSE', check: true }));
        }
        if (!force) {
            onClose && onClose(type);
        }
    }, [winId, onClose, closeConfirm, manualVisible]);
    const cancelWin = () => {
        dispatch(PopupActions.cancel({}));
    };
    useMount(() => {
        if (process.env.BUILD_ISEDM) {
            dispatch(PopupActions.registerNewWin({
                type: winType,
                id: winId,
                priority,
                notShowPeriod,
                showOnceMoreEachDay,
                forModuleId,
                forNew,
            }));
        }
    });
    useEffect(() => {
        if (winVisible) {
            if (status === 'show') {
                onShow && onShow();
            }
            else if (status === 'cancel') {
                cancelWin();
            }
            else if (status === 'close') {
                closeWin(undefined, true);
            }
        }
    }, [winVisible, status, onShow, closeWin]);
    if (!process.env.BUILD_ISEDM) {
        return React.createElement(React.Fragment, null);
    }
    if (realVisible && renderType === 'carousel' && carouselConfig) {
        if (carouselConfig) {
            return React.createElement(GuideCarousel, { config: carouselConfig, onClose: closeWin, className: className });
        }
        console.error('弹窗缺少 carouselConfig 参数');
        return React.createElement(React.Fragment, null);
    }
    if (renderType === 'custom' && children) {
        return (React.createElement(Modal, Object.assign({ centered: true, destroyOnClose: true, wrapClassName: styles.globalNotificationWrapper, className: cls([styles.globalNotificationModal, renderConfig.className]), maskClosable: false, title: title, width: 910 }, renderConfig, { maskStyle: { left: 0 }, getContainer: () => document.body, visible: realVisible, onCancel: () => closeWin('cancel'), onOk: () => closeWin('ok') }, renderConfig), children));
    }
    return React.createElement(React.Fragment, null);
};
export default PopupNotification;
